
import React, { useState } from 'react';
import { Star, X, Plus } from 'lucide-react';
import './JobPostingForm.css';

const Step2 = ({ nextStep, prevStep, setFormData }) => {
  const [skills, setSkills] = useState([]);
  const [customSkill, setCustomSkill] = useState('');

  const suggestions = [
    { name: 'MVP', preferred: false },
    { name: 'Retrofit', preferred: false },
    { name: 'Android', preferred: true },
    { name: 'Kotlin', preferred: true },
    { name: 'JavaScript', preferred: false },
    { name: 'React', preferred: false },
    { name: 'Node.js', preferred: false },
    { name: 'Python', preferred: false },
  ];

  const handleAddCustomSkill = (e) => {
    e.preventDefault();
    if (customSkill.trim() && !skills.some(skill => skill.name.toLowerCase() === customSkill.trim().toLowerCase())) {
      setSkills([...skills, { name: customSkill.trim(), preferred: false }]);
      setCustomSkill('');
    }
  };

  const handleAddSuggestion = (suggestion) => {
    if (!skills.some(skill => skill.name === suggestion.name)) {
      setSkills([...skills, suggestion]);
    }
  };

  const handleRemoveSkill = (skillName) => {
    setSkills(skills.filter(skill => skill.name !== skillName));
  };

  const handleTogglePreferred = (skillName) => {
    setSkills(skills.map(skill =>
      skill.name === skillName ? { ...skill, preferred: !skill.preferred } : skill
    ));
  };

  const handleNext = (e) => {
    e.preventDefault();
    setFormData(prev => ({ ...prev, skills }));
    nextStep();
  };

  return (
    <form onSubmit={handleNext} className="form-step-content">
      <div className="form-fields-grid">
        <div className="form-group">
          <label htmlFor="location" className="form-label">
            Location
            <span className="required-star">*</span>
          </label>
          <input
            id="location"
            type="text"
            placeholder="e.g., Hyderabad"
            className="form-control"
            required
          />
        </div>
        
        <div className="form-group">
          <label className="form-label">
            Skills
            <span className="required-star">*</span>
          </label>
          <div className="skills-container">
            <div className="selected-skills">
              {skills.map(skill => (
                <div key={skill.name} className={`skill-tag ${skill.preferred ? 'preferred' : ''}`}>
                  <div className="skill-tag-content">
                    <span className="skill-name">{skill.name}</span>
                    <div className="skill-actions">
                      <button
                        type="button"
                        className="btn-skill-action preferred"
                        onClick={() => handleTogglePreferred(skill.name)}
                      >
                        <Star size={14} fill={skill.preferred ? "#3b82f6" : "none"} color={skill.preferred ? "#3b82f6" : "#6b7280"} />
                      </button>
                      <button
                        type="button"
                        className="btn-skill-action remove"
                        onClick={() => handleRemoveSkill(skill.name)}
                      >
                        <X size={14} />
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            
            <form onSubmit={handleAddCustomSkill} className="skill-input-form">
              <input
                type="text"
                value={customSkill}
                onChange={(e) => setCustomSkill(e.target.value)}
                placeholder="Type a skill"
                className="form-control skill-input"
              />
              <button type="submit" className="btn-add-skill">
                <Plus size={16} />
                Add Skill
              </button>
            </form>
            
            <div className="suggestions-title">Suggested skills:</div>
            <div className="suggestions-list">
              {suggestions
                .filter(suggestion => !skills.some(skill => skill.name === suggestion.name))
                .map(suggestion => (
                  <button
                    key={suggestion.name}
                    type="button"
                    className="btn-suggestion"
                    onClick={() => handleAddSuggestion(suggestion)}
                  >
                    + {suggestion.name}
                  </button>
                ))}
            </div>
          </div>
        </div>
      </div>

      
    </form>
  );
};

export default Step2;